import Cookies from 'js-cookie';

export type HomeVersion = 'new' | 'old';

export type HomeRoute = '/--roboneo/home' | '/--roboneo/home_old';
export type HomePublicUrl = '/home' | '/home_old';

export const HOME_VERSION_COOKIE_KEY = 'roboneo_home_version';
export const HOME_VERSION_COOKIE_EXPIRES_DAYS = 60;

const DEFAULT_HOME_VERSION: HomeVersion = 'new';

const HOME_ROUTE_BY_VERSION: Record<HomeVersion, HomeRoute> = {
  new: '/--roboneo/home',
  old: '/--roboneo/home_old',
};

const HOME_PUBLIC_URL_BY_VERSION: Record<HomeVersion, HomePublicUrl> = {
  new: '/home',
  old: '/home_old',
};

/**
 * 记录用户选择的新旧首页版本，cookie 保留两个月供后续回首页复用。
 */
export function setHomeVersionCookie(version: HomeVersion) {
  try {
    Cookies.set(HOME_VERSION_COOKIE_KEY, version, {
      expires: HOME_VERSION_COOKIE_EXPIRES_DAYS,
      path: '/',
    });
  } catch {
    // cookie 不可用时不阻塞切换首页。
  }
}

/**
 * 读取 cookie 中选择的首页版本，非法值按未选择处理。
 */
export function getHomeVersionCookie(): HomeVersion | null {
  try {
    const version = Cookies.get(HOME_VERSION_COOKIE_KEY);
    return version === 'new' || version === 'old' ? version : null;
  } catch {
    return null;
  }
}

/**
 * 按指定版本返回带项目前缀的首页路由。
 */
export function getHomeRouteByVersion(version: HomeVersion): HomeRoute {
  return HOME_ROUTE_BY_VERSION[version];
}

/**
 * 按 cookie 中的版本返回带项目前缀的首页路由，默认新版首页。
 */
export function getCookieHomeRoute(): HomeRoute {
  return HOME_ROUTE_BY_VERSION[getHomeVersionCookie() || DEFAULT_HOME_VERSION];
}

/**
 * 按 cookie 中的版本返回当前环境可直接跳转的首页 URL。
 */
export function getCookieHomeUrl(isDevelopment: boolean): HomeRoute | HomePublicUrl {
  const version = getHomeVersionCookie() || DEFAULT_HOME_VERSION;
  return isDevelopment ? HOME_ROUTE_BY_VERSION[version] : HOME_PUBLIC_URL_BY_VERSION[version];
}
